import { Business, Home } from "@mui/icons-material";
import { Box, Button, Card, CardContent, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { quoteCreateActions } from "../../../../../../../../redux/features/quotes/quote-create-advanced";
import { QueryState } from "../../../../../../../shared/components/query-states/GlobalQueryState";
import { roleColors } from "../../../../../../../ui/colors";
import { useCategoriesQuery } from "./hooks/useCategoriesQuery";
import { orange } from "@mui/material/colors";

export const Categories = ({ selected }) => {
  const dispatch = useDispatch();
  const categoriesQuery = useCategoriesQuery();
  const { setCategory } = quoteCreateActions;

  const categories = categoriesQuery.data?.items || [];

  const iconMap = {
    Commercial: {
      //icon: <Business sx={{ fontSize: 40 }} />,
      color: orange[600],
      subtitle: "OPTIMIZE BUSINESS OPERATIONS",
      description: "Manage cleaning services for offices, buildings, or large facilities efficiently.",
    },
    Residential: {
      // icon: <Home sx={{ fontSize: 40 }} />,
      color: orange[600],
      subtitle: "PERFECT FOR HOME SERVICES",
      description: "Offer or request cleaning services for homes and apartments with full flexibility.",
    },
  };

  // --- On select category ---
  const handleSelectCategory = (cat) => {
    dispatch(setCategory(cat));
  };

  <QueryState isLoading={categoriesQuery.isLoading} isError={categoriesQuery.isError} serviceName="Categories" />;

  return (
    <Box mr={2} display="flex" justifyContent="center" alignItems="center" gap={4} flexWrap="wrap">
      {categories.map((cat) => {
        const { icon, color, subtitle, description } = iconMap[cat.name] || {};
        const imageUrl = cat.imageUrl;
        const isSelected = selected?.uid === cat.uid;

        return (
          <Card
            key={cat.uid}
            onClick={() => handleSelectCategory(cat)}
            sx={{
              flex: "1",
              borderRadius: 4,
              boxShadow: isSelected ? `0 0 0 1px ${color}60` : "0 1px 2px rgba(0,0,0,0.05)",
              border: `1px solid ${color}${isSelected ? "60" : "20"}`,
              transform: isSelected ? "translateY(-2px)" : "none",
              transition: "all 0.25s ease",
              cursor: "pointer",
              maxWidth: 360,
            }}
          >
            <CardContent sx={{ textAlign: "left", p: 4 }}>
              <Box
                sx={{
                  //backgroundColor: `${color}15`,//

                  width: 160,
                  height: 160,
                  borderRadius: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color,
                  margin: "0 auto",
                  mb: 2,
                  overflow: "hidden",
                }}
              >
                <Box
                  component="img"
                  src={imageUrl}
                  alt={cat.name}
                  sx={{
                    width: 180,
                    height: 180,
                    objectFit: "contain",
                  }}
                />
              </Box>

              <Typography variant="h6" fontWeight={700}>
                {cat.name}
              </Typography>

              <Typography variant="subtitle2" fontWeight={500} sx={{ color, mb: 1 }}>
                {subtitle}
              </Typography>

              <Typography variant="body2" sx={{ color: "text.secondary", mb: 3, lineHeight: 1.6 }}>
                {description}
              </Typography>

              <Button
                fullWidth
                sx={{
                  textTransform: "none",
                  backgroundColor: isSelected ? orange[600] : `${color}10`,
                  color: isSelected ? "#fff" : color,

                  px: 3,
                  py: 1,
                  "&:hover": {
                    backgroundColor: isSelected ? orange[600] : "var(--fx-colors-warning-100, #FFEDD5)",
                  },
                }}
              >
                {isSelected ? "Selected" : `Select ${cat.name}`}
              </Button>
            </CardContent>
          </Card>
        );
      })}
    </Box>
  );
};
